import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { IconArrowRight } from '@redteclab/icons'

import { Button, Notification } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { urlResolverGetRedeemPaperPrescription } from '../../../url-handling'
import { productAccessorHasViaslimOdsPartner } from '../../model/productAccessor/productAccessorHasViaslimOdsPartner'
import { productAccessorIsProductNotInCatalog } from '../../model/productAccessor/productAccessorIsProductNotInCatalog'
import { PRODUCT_TEMPLATES } from '../../model/productTemplates'
import { useProductPageContext } from '../productPageContext'
import { ProductPageOdsDialogCtaButtonCh } from '../ProductPageOdsDialogCH/ProductPageOdsDialogCtaButtonCh'

import { ProductBuyBoxStockStatus } from './ProductBuyBoxStockStatusAndDeliveryInfo/ProductBuyBoxStockStatus'

const useShallOdsButtonRender = (): boolean => {
  const { currentVariant, productPageOdsConfig, productTemplate } =
    useProductPageContext()

  return (
    productTemplate === PRODUCT_TEMPLATES.RX &&
    productAccessorHasViaslimOdsPartner(currentVariant) &&
    productPageOdsConfig !== null
  )
}

export const ProductBuyBoxRxCh: FC = () => {
  const i18n = useIntl()
  const globalConfig = useGlobalConfigContext()
  const mediserviceUrl = urlResolverGetRedeemPaperPrescription(globalConfig)
  const shouldShowOdsButton = useShallOdsButtonRender()
  const { currentVariant } = useProductPageContext()
  const productNotInCatalog = productAccessorIsProductNotInCatalog(
    currentVariant.stock_status,
  )

  return (
    <div className="w-full rounded-2xl bg-light-primary-medium px-4 pb-2.5 pt-5">
      <Notification
        className=""
        severity="info"
        title={i18n.formatMessage({
          id: 'chrx.product.buyBox.title',
        })}
        variant="secondary"
      >
        {shouldShowOdsButton ? (
          <FormattedMessage id="chrx.product.buyBox.messageWithOds" />
        ) : (
          <FormattedMessage id="chrx.product.buyBox.message" />
        )}
      </Notification>
      {productNotInCatalog ? (
        <div className="mt-2">
          <ProductBuyBoxStockStatus />
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          {shouldShowOdsButton ? <ProductPageOdsDialogCtaButtonCh /> : null}
          <Button<'a'>
            className={clsx(
              'w-full whitespace-pre-wrap',
              shouldShowOdsButton ? 'mb-2.5' : 'mt-4',
            )}
            data-qa-id="go-to-mediservice-button"
            endIcon={<IconArrowRight />}
            href={mediserviceUrl}
            slots={{ root: 'a' }}
            variant={shouldShowOdsButton ? 'outlined' : 'filled'}
          >
            <FormattedMessage id="general.link.label.recipe" />
          </Button>
        </div>
      )}
    </div>
  )
}
